var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player-container"},[_c('video',_vm._g(_vm._b({attrs:{"controls":""}},'video',_vm.$attrs,false),_vm.$listeners),[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }